import { render, staticRenderFns } from "./DescTemp.vue?vue&type=template&id=75a9e218&"
import script from "./DescTemp.vue?vue&type=script&lang=js&"
export * from "./DescTemp.vue?vue&type=script&lang=js&"
import style0 from "./DescTemp.vue?vue&type=style&index=0&id=75a9e218&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports